import React from "react";
import type { WorkerAppointment } from "../types";
import { WorkerAppointmentsCardList } from "./worker-appointments-card-list";
import { WorkerAppointmentsTable } from "./worker-appointments-table";

interface WorkerAppointmentsListProps {
  appointments: WorkerAppointment[];
  showQuickActions?: boolean;
  onAppointmentClick?: (appointment: WorkerAppointment) => void;
}

export function WorkerAppointmentsList({
  appointments,
  showQuickActions = true,
  onAppointmentClick,
}: WorkerAppointmentsListProps) {
  return (
    <React.Fragment>
      {/* Mobile Cards */}
      <WorkerAppointmentsCardList
        appointments={appointments}
        showQuickActions={showQuickActions}
        onAppointmentClick={onAppointmentClick}
      />

      {/* Desktop Table */}
      <WorkerAppointmentsTable
        appointments={appointments}
        showQuickActions={showQuickActions}
        onAppointmentClick={onAppointmentClick}
      />
    </React.Fragment>
  );
}
